"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.combineMuteStatusWithAudioSourceInProgram = exports.attachAudioPresenterSources = exports.addUnChangedBannerLayerToProgram = exports.addAudioPresentersToProgramLayer = exports.UNASSIGNED = exports.EMPTY_THUMBNAIL = void 0;
exports.filteredScenesForUpdate = filteredScenesForUpdate;
exports.findAndUpdate = findAndUpdate;
exports.findAndUpdateEmptySourceTitle = findAndUpdateEmptySourceTitle;
exports.formatBannerMarkup = formatBannerMarkup;
exports.generateBanner = generateBanner;
exports.getMediaSourceValueObject = exports.getMediaSourceElement = exports.getMediaSettings = exports.getLiveCameraSources = exports.getIsStagedSourcesActive = exports.getElapsedTime = exports.getAudioSourceInProgram = exports.getActiveSourceForUser = void 0;
exports.getMinutesDifference = getMinutesDifference;
exports.getSourceFromResponse = exports.getSourceFromProgramLayers = exports.getSourceFirstNameLastName = exports.getSignedUrl = exports.getSceneLayout = exports.getProgramLayers = void 0;
exports.getSourceValue = getSourceValue;
exports.isItemValid = exports.isInitializing = exports.isImageSource = exports.isDuplicateRequest = exports.isDisconnected = exports.isDirectorRequest = exports.isCameraPresenter = exports.isAvailableSource = exports.isAudioVideoSource = exports.isAudioSource = exports.isAssignedPresenterSource = exports.hasSameAudioVideoSource = exports.groupById = exports.getUnassignedMediaSources = exports.getStreamSource = exports.getStartedOn = exports.getSourcesSignedUrl = exports.getSourceValueChanges = void 0;
exports.isLayout = isLayout;
exports.reValidateAudioPresentersInProgramLayers = exports.isVideoSource = exports.isUnassigned = exports.isSourceInProgram = exports.isScreenPresenter = exports.isPresenterSource = exports.isPendingKnock = exports.isPdfSource = exports.isObjectSourceValue = exports.isMediaSourceExcludeAudio = exports.isMediaSource = exports.isMediaOrPresenterSource = void 0;
exports.removeH2FromPresenterBannerMarkup = removeH2FromPresenterBannerMarkup;
exports.sanitizeHTML = exports.resetNotLiveVideoSource = void 0;
exports.sourcesWithPreviousDisconnectedState = sourcesWithPreviousDisconnectedState;
exports.withAttendeeCameraStatus = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _underscore = require("underscore");
var _moment = _interopRequireDefault(require("moment"));
var _constants = require("../../constants");
var _constants2 = require("@studio/constants");
var _excluded = ["layer", "source"];
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof3(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof3(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/** Check if layout is a valid layout */
function isLayout(layout, compare) {
  return (layout === null || layout === void 0 ? void 0 : layout.title) === (compare === null || compare === void 0 ? void 0 : compare.title) || (layout === null || layout === void 0 ? void 0 : layout.id) === (compare === null || compare === void 0 ? void 0 : compare.id);
}

/**
 * Get an object value even when the value is in "legacy" format for media sources (used to be just the event doc ID)
 * @param {*} value
 */
var getMediaSourceValueObject = exports.getMediaSourceValueObject = function getMediaSourceValueObject(value) {
  return typeof value === 'string' ? {
    eventDocId: value
  } : value;
};

/**
 * Gets the time difference in minutes given two timestamps
 * @param {number} startTime
 * @param {number} finishTime
 */
function getMinutesDifference(startTime, finishTime) {
  var difference = Math.abs(finishTime - startTime);
  return Math.floor(difference / 1000 / 60); // milliseconds / seconds
}

/** Check that the item is not undefined or null */
var isItemValid = exports.isItemValid = function isItemValid(item) {
  return !!item;
};

/**
 * Check if Audio Source
 */
var isAudioSource = exports.isAudioSource = function isAudioSource(source) {
  return source && source.type === _constants.AUDIO_FILE;
};

/**
 * Check if Video Source
 */
var isVideoSource = exports.isVideoSource = function isVideoSource(source) {
  return source && source.type === _constants.VIDEO_FILE;
};

/** Check if source is an image source */
var isImageSource = exports.isImageSource = function isImageSource(source) {
  return source && source.type === _constants.IMAGE_FILE;
};

/**

  /** Check if source is a PDF source */
var isPdfSource = exports.isPdfSource = function isPdfSource(source) {
  return source && source.type === _constants.PDF_FILE;
};

/**

   * Check if Camera presenter
   */
var isCameraPresenter = exports.isCameraPresenter = function isCameraPresenter(source) {
  return source && source.type === _constants.CAMERA_PRESENTER;
};
var isScreenPresenter = exports.isScreenPresenter = function isScreenPresenter(source) {
  return source && source.type === _constants.SCREEN_PRESENTER;
};
/**
 * Check if Media with an Audio source
 */
var isAudioVideoSource = exports.isAudioVideoSource = function isAudioVideoSource(source) {
  return [_constants.VIDEO_FILE, _constants.AUDIO_FILE].includes(source.type);
};

/**
 * CHeck if Media source
 */
var isMediaSource = exports.isMediaSource = function isMediaSource(source) {
  return [_constants.VIDEO_FILE, _constants.AUDIO_FILE, _constants.IMAGE_FILE, _constants.PDF_FILE, _constants.MEDIA].includes(source.type);
};
var isMediaSourceExcludeAudio = exports.isMediaSourceExcludeAudio = function isMediaSourceExcludeAudio(source) {
  return [_constants.VIDEO_FILE, _constants.IMAGE_FILE, _constants.PDF_FILE, _constants.MEDIA].includes(source.type);
};
var UNASSIGNED = exports.UNASSIGNED = 'Unassigned';
var EMPTY_THUMBNAIL = exports.EMPTY_THUMBNAIL = 'EmptyThumbnail';

/**
 * Check if presenter source
 */
var isPresenterSource = exports.isPresenterSource = function isPresenterSource(source) {
  return [_constants.CAMERA_PRESENTER, _constants.SCREEN_PRESENTER].includes(source.type);
};
var isAssignedPresenterSource = exports.isAssignedPresenterSource = function isAssignedPresenterSource(source) {
  return isPresenterSource(source) && source.value !== UNASSIGNED;
};

/**
 * Check if source.value is type object
 */
var isObjectSourceValue = exports.isObjectSourceValue = function isObjectSourceValue(sourceValue) {
  return (0, _typeof2["default"])(sourceValue) === 'object';
};
var isMediaOrPresenterSource = exports.isMediaOrPresenterSource = function isMediaOrPresenterSource(source) {
  return isMediaSource(source) || isPresenterSource(source);
};
/**
 * Get Source Value changes
 */
var getSourceValueChanges = exports.getSourceValueChanges = function getSourceValueChanges(source, serverTimeDelta) {
  var sourceValue = source.value,
    hidden = source.hidden;
  if (isAudioVideoSource(source)) {
    var isPlaying = sourceValue.isPlaying && hidden ? true : !sourceValue.isPlaying;
    return _objectSpread(_objectSpread({}, sourceValue), {}, {
      seek: 0,
      // Some sources have isPlaying value already set to true
      isPlaying: isPlaying,
      startedOn: getStartedOn(isPlaying, serverTimeDelta)
    });
  }
  return sourceValue;
};
var getSourceFromProgramLayers = exports.getSourceFromProgramLayers = function getSourceFromProgramLayers(layers, predicate) {
  return layers === null || layers === void 0 ? void 0 : layers.map(function (layer) {
    return layer === null || layer === void 0 ? void 0 : layer.source;
  }).filter(predicate);
};
var getIsStagedSourcesActive = exports.getIsStagedSourcesActive = function getIsStagedSourcesActive(stagedSourcesMap) {
  return Object.keys(stagedSourcesMap).reduce(function (acc, sId) {
    return acc || stagedSourcesMap[sId];
  }, false);
};
var getMediaSourceElement = exports.getMediaSourceElement = function getMediaSourceElement(sourceId) {
  return document.getElementById("media_player_".concat(sourceId));
};
var getStartedOn = exports.getStartedOn = function getStartedOn(isPlaying) {
  var serverTimeDelta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return isPlaying ? (0, _moment["default"])().utc().unix() - serverTimeDelta + _constants.PLAY_DELAY : undefined;
};

/**
 * Reset unhidden video source to seek position 0
 *
 * @param liveSources
 * @param sources
 * @param dispatch
 * @param updateSource updateSource function
 * @returns {*}
 */
var resetNotLiveVideoSource = exports.resetNotLiveVideoSource = function resetNotLiveVideoSource(liveSources, sources, serverTimeDelta, dispatch, updateSource) {
  var sourceToUpdate = null;
  var resetSources = sources.map(function (source) {
    var _id = source._id,
      type = source.type,
      hidden = source.hidden;
    if (type === _constants.VIDEO_FILE && !hidden && !liveSources.includes(_id)) {
      source.value = _objectSpread(_objectSpread({}, source.value), {}, {
        seek: 0,
        isPlaying: true,
        startedOn: getStartedOn(true, serverTimeDelta)
      });
      sourceToUpdate = source;
      return source;
    }
    return source;
  });
  if (sourceToUpdate) {
    var _sourceToUpdate = sourceToUpdate,
      _id = _sourceToUpdate._id,
      value = _sourceToUpdate.value;
    dispatch(updateSource(_id, {
      value: value
    }));
  }
  return resetSources;
};

/**
 * This function returns the social icon from RTMP url
 * @param {String} url to screen
 * @return {Object} returns the vendor name of the stream source
 */

var streamNames = ['facebook', 'vimeo', 'youtube', 'bcovelive', 'twitter', 'twitch', 'linkedin', 'wowza', 'streaming', 'play', 'stop', 'recording', 'inactiveStream', 'activeRecording', 'inactiveRecording'];
var getStreamSource = exports.getStreamSource = function getStreamSource(url) {
  if (!url) {
    return 'recordingEllipse';
  }
  var source = 'rtmp';
  if (url) {
    streamNames.forEach(function (name) {
      if (url.includes(name)) {
        source = name;
      }
    });
  }
  return source;
};

/**
 * This function returns difference in time from given date param with current date
 * @param {String} startedAt the start date in string
 * @return {Number} returns the difference from now and startedAt
 */
var getElapsedTime = exports.getElapsedTime = function getElapsedTime(startedAt) {
  var currentServerTime = (0, _moment["default"])(startedAt).valueOf();
  var currentLocalTime = (0, _moment["default"])().valueOf();
  var elapsedTime = currentLocalTime - currentServerTime;
  return elapsedTime;
};

/**
 * This function groups an array by _id attribute as key to object mapping
 * @param {String} array the start date in string
 * @return {Number} returns the difference from now and startedAt
 */
var groupById = exports.groupById = function groupById(array) {
  return array.reduce(function (accumulator, currentObject) {
    var _id = currentObject._id;
    accumulator[_id] = currentObject;
    return accumulator;
  }, {});
};
var isSourceInProgram = exports.isSourceInProgram = function isSourceInProgram() {
  var layers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var sourceId = arguments.length > 1 ? arguments[1] : undefined;
  // Check if source exists in program layer
  var _layers$filter$filter = layers.filter(function (layer) {
      return isItemValid(layer);
    }).filter(function (layer) {
      var _layer$source;
      return (layer === null || layer === void 0 ? void 0 : (_layer$source = layer.source) === null || _layer$source === void 0 ? void 0 : _layer$source._id) === sourceId;
    }),
    _layers$filter$filter2 = (0, _slicedToArray2["default"])(_layers$filter$filter, 1),
    layerSource = _layers$filter$filter2[0];
  return !!layerSource;
};
var getAudioSourceInProgram = exports.getAudioSourceInProgram = function getAudioSourceInProgram() {
  var layers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  // Check if audio source exists in program layer
  var audioSource = layers.find(function (layer) {
    return isAudioSource(layer.source);
  });
  return audioSource === null || audioSource === void 0 ? void 0 : audioSource.source;
};
var getUnassignedMediaSources = exports.getUnassignedMediaSources = function getUnassignedMediaSources(sources) {
  var unAssignedMediaSources = sources.filter(function (source) {
    return source.type === _constants.MEDIA && source.value === '';
  });
  return unAssignedMediaSources;
};

// we are creating and audioPresenter for each screenPresenter or cameraPresenter that is unmuted
var attachAudioPresenterSources = exports.attachAudioPresenterSources = function attachAudioPresenterSources(sources, attendeeMuteStatus) {
  var unMutedPresenters = sources && sources.filter(function (s) {
    var sourceValue = getSourceValue(s);
    return s && [_constants.CAMERA_PRESENTER, _constants.SCREEN_PRESENTER].includes(s.type) && s.value && !attendeeMuteStatus[sourceValue];
  }) || [];
  // This should make sure that duplicate audio presenter is not added to program
  var audioPresenterSources = [];
  unMutedPresenters.forEach(function (source) {
    var sourceValue = getSourceValue(source);
    var audioSourceIndex = sources.findIndex(function (s) {
      return s.value === source._id && s.type === _constants.AUDIO_PRESENTER;
    });
    if (audioSourceIndex <= -1) {
      audioPresenterSources.push(_objectSpread(_objectSpread({}, source), {}, {
        _id: sourceValue,
        type: _constants.AUDIO_PRESENTER,
        value: source._id
      }));
    }
  });
  return sources ? sources.concat(audioPresenterSources) : [];
};

/**
 * This will make sure all audio presenter source in program has
 * a matching source from either camera / screen presenter
 * @param {Object} layers takes a layers of a program to validate
 * @param {Object} sources from broadcast sources
 * @return {Object} returns an updated program object that has been validated
 */
var reValidateAudioPresentersInProgramLayers = exports.reValidateAudioPresentersInProgramLayers = function reValidateAudioPresentersInProgramLayers(layers, sources) {
  var presenters = sources.filter(function (s) {
    return [_constants.CAMERA_PRESENTER, _constants.SCREEN_PRESENTER].includes(s.type);
  });
  return layers.filter(function (layer) {
    return presenters.findIndex(function (presenter) {
      return layer.source.value === presenter.value;
    }) > -1 || ![_constants.CAMERA_PRESENTER, _constants.SCREEN_PRESENTER, _constants.AUDIO_PRESENTER].includes(layer.source.type);
  });
};

/**
 * This will add audio sources to program for any unMuted presenter given the attendeeId
 * @param {Object} layers takes a layers of a program to validate
 * @param {Object} sources with audio presenter sources
 * @return {Object} returns an updated program object that has been validated
 */
var addAudioPresentersToProgramLayer = exports.addAudioPresentersToProgramLayer = function addAudioPresentersToProgramLayer(layers, sources) {
  var filterAudioPresenter = sources.filter(function (s) {
    return s && s.type === _constants.AUDIO_PRESENTER;
  });
  var audioPresenterLayer = filterAudioPresenter.map(function (source) {
    return {
      _id: source._id,
      source: source,
      layer: {}
    };
  });
  layers = layers.concat(audioPresenterLayer);
  return layers;
};

/**
 * This is expected to retain the current banner in state.
 * @param {Object} withAudioPresenterLayer a just updated program object that has the audioPresenter validated
 * @param {Object} program current program in state
 * @return {Object} returns an updated program object that has the correct banner layer
 */

var addUnChangedBannerLayerToProgram = exports.addUnChangedBannerLayerToProgram = function addUnChangedBannerLayerToProgram(withAudioPresenterLayer, program) {
  return withAudioPresenterLayer.map(function (layer) {
    var source = layer.source;
    // Updates the withAudioPresenterLayer with the correct program layer
    if (source && (source === null || source === void 0 ? void 0 : source.type) === 'banner') {
      var programLayer = program === null || program === void 0 ? void 0 : program.layers.find(function (programLayer) {
        return (programLayer === null || programLayer === void 0 ? void 0 : programLayer.source._id) === source._id;
      });

      /** What happens if programLayer is undefined? */
      return programLayer || layer;
    }
    return layer;
  });
};

/**
 * @description This will generate mock banner given the banner template type
 * @param {string} templateType
 * @param {boolean} hidden
 */
function generateBanner(templateType) {
  var hidden = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var banner = {
    layer: {},
    source: {
      hidden: hidden,
      value: {
        templateVars: {},
        templateType: templateType,
        markup: '<section><h1>Presenter name</h1><h2>Presenter title</h2></section>'
      }
    }
  };
  return banner;
}

/**
 * @description Sanitize html from string
 * @param {string} str
 * @returns String return sanitised string
 */
var sanitizeHTML = exports.sanitizeHTML = function sanitizeHTML(str) {
  if (!str) {
    return '';
  }
  return str.replace(/[^\w. ]/gi, function (c) {
    return '&#' + c.charCodeAt(0) + ';';
  });
};

/**
 * @description Formats presenter banner markup
 * @param {string} title
 * @param {string} description
 * @param {string} markup
 * @returns Object
 */
function formatBannerMarkup(title, description, markup, templateVars) {
  var bannerStyle = {
    height: '40px',
    position: 'absolute',
    bottom: '5px',
    left: '5px'
  };
  var titleStyle = {};
  var subTitleStyle = {
    paddingBottom: '6px'
  };
  var bannerMarkup = markup;
  // Replace title placeholder with actual presenter title
  bannerMarkup = bannerMarkup.replace(_constants.BANNER_PLACEHOLDERS.title, sanitizeHTML(title));
  if (templateVars && templateVars.useAccentAsBackground && templateVars.ACCENT_COLOR) {
    // Replace background color for section
    bannerMarkup = bannerMarkup.replace(/background: #[a-fA-F0-9]+;/g, "background: ".concat(templateVars.ACCENT_COLOR, ";"));
  }
  if (description) {
    // Replace description placeholder with actual presenter description
    bannerMarkup = bannerMarkup.replace(_constants.BANNER_PLACEHOLDERS.description, sanitizeHTML(description));
  } else {
    bannerStyle.height = '27px';
    titleStyle = {
      paddingTop: '5px'
    };
    /**
     * Remove H2 tag `Presenter title` since we don't
     * have source description to display here.
     */
    bannerMarkup = removeH2FromPresenterBannerMarkup(bannerMarkup);
  }
  return {
    bannerStyle: bannerStyle,
    bannerMarkup: bannerMarkup,
    titleStyle: titleStyle,
    subTitleStyle: subTitleStyle
  };
}

/**
 * @description Returns a source value. if the value is unassigned,
 * it returns a concatenated value with the source id
 * @param {Object} source
 * @returns String
 */
function getSourceValue(source) {
  var sourceValue = source.value;
  if (sourceValue === UNASSIGNED) {
    sourceValue = "".concat(UNASSIGNED, "-").concat(source._id);
  }
  return sourceValue;
}

/**
 * @description This passes every scene and returns an updated scenes array
 * trimmed enough with the valid structure for an api update call.
 * @param {Object} scenes
 * @returns Array
 */
function filteredScenesForUpdate(scenes) {
  return scenes.map(function (scene) {
    // remove duplicate source layers
    return (0, _underscore.pick)(_objectSpread(_objectSpread({}, scene), {}, {
      layers: scene.layers.map(function (l) {
        return _objectSpread(_objectSpread({}, l), {}, {
          source: (0, _underscore.pick)(l.source, ['_id', 'title', 'type', 'value', 'hidden', 'order', 'thumbnail', 'description'])
        });
      })
    }), ['_id', 'description', 'title', 'layers', 'style', 'thumbnail', 'layout']);
  });
}
/**
 * Returns the layout for the scene
 * @param {Object} scene
 * @return {{id: *, title: *}}
 */
var getSceneLayout = exports.getSceneLayout = function getSceneLayout(scene) {
  var sceneLayout = {
    id: scene.layout,
    title: scene.title
  };
  // Change featured layout to grid when no featured source exist to avoid assigning placeholder default
  var isFeatured = isLayout(sceneLayout, _constants.FEATURED_SCREEN) || isLayout(sceneLayout, _constants.FEATURED_MEDIA) || isLayout(sceneLayout, _constants.FEATURED_PRESENTER);
  if (isFeatured) {
    var hasFeaturedSource = scene.layers.some(function (_ref) {
      var layer = _ref.layer,
        source = _ref.source;
      var isAFeaturedFile = [_constants.IMAGE_FILE, _constants.PDF_FILE, _constants.VIDEO_FILE, _constants.MEDIA, _constants.SCREEN_PRESENTER].includes(source.type);
      return isAFeaturedFile && (layer.isContent === undefined || layer.isContent === true);
    });
    if (!hasFeaturedSource) {
      sceneLayout = _constants.GRID;
      scene.layout = sceneLayout.id;
      scene.title = sceneLayout.title;
    }
  }
  return sceneLayout;
};

/**
 * Use to determine if the current knock type is a duplicate
 * @param {*} knock
 * @param {*} receivedKnock
 * @returns boolean
 */
var isDuplicateRequest = exports.isDuplicateRequest = function isDuplicateRequest(knock, receivedKnock) {
  return knock.presenterId === receivedKnock.presenterId && knock.type === receivedKnock.type && (knock.status || receivedKnock.status) === _constants.PENDING;
};

/**
 * Retrieves the active source for a given user from the broadcast sources.
 *
 * @param {Array} broadcastSources - The array of broadcast sources.
 * @param {string} userId - The ID of the studio user.
 * @returns {Object|undefined} - The active source object for the user, or undefined if not found.
 */
var getActiveSourceForUser = exports.getActiveSourceForUser = function getActiveSourceForUser(broadcastSources, userId) {
  return broadcastSources === null || broadcastSources === void 0 ? void 0 : broadcastSources.sources.find(function (element) {
    return (element === null || element === void 0 ? void 0 : element.user) === userId && (element === null || element === void 0 ? void 0 : element.value) !== 'Unassigned' && !(element !== null && element !== void 0 && element.isInitializing);
  });
};

/**
 * Util function to check if a knock status is pending
 * @param {*} kn
 * @returns boolean
 */
var isPendingKnock = exports.isPendingKnock = function isPendingKnock(kn) {
  return kn.status === _constants.PENDING;
};

/**
 * Check if knock is a director request type
 * Director request is one of microphone/canUnmute, screenshare/canScreenShare, camera/canToggleCamera,
 * @param {*} requestType
 * @returns boolean
 */
var isDirectorRequest = exports.isDirectorRequest = function isDirectorRequest(requestType) {
  return [_constants.MICROPHONE, _constants.SCREENSHARE, _constants.CAMERA].includes(requestType);
};

/**
 * @description Get camera sources from program layers
 * @param {[]} layers
 * @returns []
 */
var getLiveCameraSources = exports.getLiveCameraSources = function getLiveCameraSources(layers) {
  return layers.filter(function (_ref2) {
    var source = _ref2.source;
    return source.type === _constants.CAMERA_PRESENTER && source.value !== UNASSIGNED;
  });
};

/**
 * Knock request unassigned presenter filters
 */
var isUnassigned = exports.isUnassigned = function isUnassigned(source) {
  return source.value === UNASSIGNED;
};

/**
 * Knock request unassigned presenter filters
 */
var isInitializing = exports.isInitializing = function isInitializing(source) {
  return source.isInitializing === true;
};

/** Predicate to check that the source is unassigned and disconnected */
var isDisconnected = exports.isDisconnected = function isDisconnected(source) {
  return source.value !== UNASSIGNED && source.disconnected;
};

/** Checks that the source is assigned and not in the attendee tile state */
var isAvailableSource = exports.isAvailableSource = function isAvailableSource(source, attendeeIds) {
  return source.value !== UNASSIGNED && !attendeeIds.includes(source.value);
};

/**
 * @param {Array} sourceLayers The source layers
 * @param {Array} destinationLayers The destination layers
 * @return {Boolean}
 */
var hasSameAudioVideoSource = exports.hasSameAudioVideoSource = function hasSameAudioVideoSource(sourceLayers) {
  var _sourceLayer$source, _destinationLayer$sou;
  var destinationLayers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var sourceLayer = sourceLayers === null || sourceLayers === void 0 ? void 0 : sourceLayers.find(function (_ref3) {
    var source = _ref3.source;
    return isAudioVideoSource(source);
  });
  var destinationLayer = destinationLayers.filter(function (layer) {
    return isItemValid(layer);
  }).find(function (_ref4) {
    var source = _ref4.source;
    return isAudioVideoSource(source);
  });
  return sourceLayer && destinationLayer && (sourceLayer === null || sourceLayer === void 0 ? void 0 : (_sourceLayer$source = sourceLayer.source) === null || _sourceLayer$source === void 0 ? void 0 : _sourceLayer$source._id) === (destinationLayer === null || destinationLayer === void 0 ? void 0 : (_destinationLayer$sou = destinationLayer.source) === null || _destinationLayer$sou === void 0 ? void 0 : _destinationLayer$sou._id);
};

/**
    @description Removes `<H2/>` from presenter banner markup
    @param {string} markup
   */
function removeH2FromPresenterBannerMarkup(markup) {
  var removeH2 = /<h2[^>]*>[^</]*<\/h2>/gi;
  return markup === null || markup === void 0 ? void 0 : markup.replace(removeH2, '');
}
var sourcesSignedUrlCache = {
  lastUpdated: new Date().getTime()
};

/**
    Returns a single source with signed url
    @param {{}} source
    @param {{}} apiClient
    @param {{}} forceFetch - Force fetch the signed URL by skipping cache
    @returns {{}} source with signed url.
   */
var getSignedUrl = exports.getSignedUrl = /*#__PURE__*/function () {
  var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(source, apiClient) {
    var _source$value;
    var forceFetch,
      value,
      eventDocId,
      signedUrl,
      _yield$apiClient$even,
      url,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          forceFetch = _args.length > 2 && _args[2] !== undefined ? _args[2] : false;
          if (!(!(source !== null && source !== void 0 && source.value) || isPresenterSource(source) || (source === null || source === void 0 ? void 0 : (_source$value = source.value) === null || _source$value === void 0 ? void 0 : _source$value.type) === _constants2.STOCK_MEDIA)) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return", source);
        case 3:
          value = getMediaSourceValueObject(source.value);
          eventDocId = value.eventDocId;
          signedUrl = sourcesSignedUrlCache[eventDocId];
          if (!((!signedUrl || forceFetch) && source.team && source.event)) {
            _context.next = 13;
            break;
          }
          _context.next = 9;
          return apiClient.eventDoc.getSignedUrl(source.team, source.event, eventDocId);
        case 9:
          _yield$apiClient$even = _context.sent;
          url = _yield$apiClient$even.url;
          signedUrl = url;
          sourcesSignedUrlCache[eventDocId] = url;
        case 13:
          return _context.abrupt("return", _objectSpread(_objectSpread({}, source), {}, {
            value: _objectSpread(_objectSpread({}, value), {}, {
              url: signedUrl
            })
          }));
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getSignedUrl(_x, _x2) {
    return _ref5.apply(this, arguments);
  };
}();

/**
    Maps a list of sources to signed urls
    @param {[]} sources
    @param {{}} apiClient
    @param {string} teamId
    @param {string} eventId
   */
var getSourcesSignedUrl = exports.getSourcesSignedUrl = /*#__PURE__*/function () {
  var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(sources, apiClient, teamId, eventId) {
    var minutes, isValidCache, eventDocIds, _yield$apiClient$even2, urls, sourcesWithSignedUrls;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          minutes = getMinutesDifference(sourcesSignedUrlCache.lastUpdated, new Date().getTime());
          isValidCache = minutes < _constants.SIGNED_URLS_CACHE_TIMEOUT_VALUE;
          eventDocIds = sources === null || sources === void 0 ? void 0 : sources.reduce(function (accumulator, source) {
            var value = source.value,
              type = source.type;
            if (!_constants.S3SourceTypes.includes(type)) {
              return accumulator;
            }
            var _getMediaSourceValueO = getMediaSourceValueObject(value),
              eventDocId = _getMediaSourceValueO.eventDocId;
            if (!eventDocId || (value === null || value === void 0 ? void 0 : value.type) === _constants2.STOCK_MEDIA) {
              return accumulator;
            }
            var signedUrl = sourcesSignedUrlCache[eventDocId];
            if (signedUrl && isValidCache) {
              return accumulator;
            }
            accumulator.push(eventDocId);
            return accumulator;
          }, []);
          if (!(eventDocIds !== null && eventDocIds !== void 0 && eventDocIds.length)) {
            _context2.next = 9;
            break;
          }
          _context2.next = 6;
          return apiClient.eventDoc.getSignedUrls(teamId, eventId, {
            eventDocs: eventDocIds
          });
        case 6:
          _yield$apiClient$even2 = _context2.sent;
          urls = _yield$apiClient$even2.urls;
          // update sourcesSignedUrlCache including last updated timestamp.
          sourcesSignedUrlCache = _objectSpread(_objectSpread(_objectSpread({}, sourcesSignedUrlCache), urls), {}, {
            lastUpdated: new Date().getTime()
          });
        case 9:
          sourcesWithSignedUrls = sources === null || sources === void 0 ? void 0 : sources.map(function (source) {
            var value = source.value,
              type = source.type;
            if (!_constants.S3SourceTypes.includes(type)) {
              return source;
            }

            // Convert to source object for legacy media files which has value as string
            var valueObj = getMediaSourceValueObject(value);
            var eventDocId = valueObj.eventDocId;
            if (!eventDocId || (value === null || value === void 0 ? void 0 : value.type) === _constants2.STOCK_MEDIA) {
              return source;
            }
            var signedUrl = sourcesSignedUrlCache[eventDocId];
            return _objectSpread(_objectSpread({}, source), {}, {
              value: _objectSpread(_objectSpread({}, valueObj), {}, {
                url: signedUrl
              })
            });
          });
          return _context2.abrupt("return", sourcesWithSignedUrls);
        case 11:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function getSourcesSignedUrl(_x3, _x4, _x5, _x6) {
    return _ref6.apply(this, arguments);
  };
}();
var isFulfilled = function isFulfilled(status) {
  return status === 'fulfilled';
};

/**
    @param {[]} response
   */
var getSourceFromResponse = exports.getSourceFromResponse = function getSourceFromResponse(response) {
  return response.reduce(function (memo, item) {
    var status = item.status,
      value = item.value;
    return isFulfilled(status) ? [].concat((0, _toConsumableArray2["default"])(memo), [value]) : memo;
  }, []);
};

/**
 * Gets the layers in a scene or program
 * @param {*} program scene/program
 * @returns Layer[] Array of layers
 */
var getProgramLayers = exports.getProgramLayers = function getProgramLayers(program) {
  var layers = (program === null || program === void 0 ? void 0 : program.layers) || [];
  return layers === null || layers === void 0 ? void 0 : layers.filter(function (layer) {
    return isItemValid(layer);
  });
};
var withAttendeeCameraStatus = exports.withAttendeeCameraStatus = function withAttendeeCameraStatus(program) {
  var attendeeCameraStatus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var currentLayers = getProgramLayers(program).map(function (_ref7) {
    var layer = _ref7.layer,
      source = _ref7.source,
      rest = (0, _objectWithoutProperties2["default"])(_ref7, _excluded);
    var currentLayer = _objectSpread({
      source: source,
      layer: layer
    }, rest);
    if (isPresenterSource(source) && typeof attendeeCameraStatus[source.value] === 'boolean') {
      return _objectSpread(_objectSpread({}, currentLayer), {}, {
        layer: _objectSpread(_objectSpread({}, layer), {}, {
          isCameraOn: attendeeCameraStatus[source.value]
        })
      });
    }
    return currentLayer;
  });
  return _objectSpread(_objectSpread({}, program), {}, {
    layers: currentLayers
  });
};

/** Reducer util function to find and update broadcast sources
 *
 * Implementation update is to take account of the order of sources in the array
 * as it will have a direct impact on the program when sources are reordered.
 * */
function findAndUpdate(oldSources, updatedSources) {
  return (0, _toConsumableArray2["default"])(oldSources).reduce(function (a, c) {
    var updatedSource = (0, _underscore.find)(updatedSources, function (us) {
      return us._id === c._id;
    });
    if (!updatedSource) {
      a.push(c);
    }
    return a;
  }, (0, _toConsumableArray2["default"])(updatedSources));
}

/** Reducer util function to find sources with disconnected state
 *
 * Implementation update is to take account of the order of sources in the array
 * as it will have a direct impact on the program when sources are reordered.
 * */
function sourcesWithPreviousDisconnectedState(newSources, oldSources) {
  return (0, _toConsumableArray2["default"])(newSources).reduce(function (a, s) {
    var oldIndex = (0, _underscore.findIndex)(oldSources, function (oldSource) {
      return oldSource._id === s._id;
    });
    if (oldIndex > -1) {
      a[oldIndex] = _objectSpread(_objectSpread({}, s), {}, {
        disconnected: oldSources[oldIndex].disconnected,
        isInitializing: oldSources[oldIndex].isInitializing || false
      });
    } else {
      a.push(s);
    }
    return a;
  }, []).filter(function (s) {
    return !!s;
  });
}
/*
    This function sets the title of sources without titles to an empty string
  */
function findAndUpdateEmptySourceTitle(sources) {
  return sources.map(function (s) {
    if (!s.title) {
      s.title = '';
    }
    return s;
  });
}

/**
 * This will extend the attendeeMuteStatus object from store with sources
 * mute status in program
 */
var combineMuteStatusWithAudioSourceInProgram = exports.combineMuteStatusWithAudioSourceInProgram = function combineMuteStatusWithAudioSourceInProgram(sources, program, attendeeMuteStatus) {
  var extendedAttendeeMuteStatus = program.layers.reduce(function (muteStatue, _ref8) {
    var source = _ref8.source;
    if (source.value === UNASSIGNED && source.type === _constants.CAMERA_PRESENTER) {
      var sourceValue = getSourceValue(source);
      var hasSource = isSourceInProgram(program.layers, sourceValue);
      if (hasSource) {
        muteStatue[sourceValue] = false;
      }
    }
    return muteStatue;
  }, _objectSpread({}, attendeeMuteStatus));
  extendedAttendeeMuteStatus = sources.reduce(function (muteStatue, source) {
    if (source.type === _constants.CAMERA_PRESENTER) {
      var sourceValue = getSourceValue(source);
      if (extendedAttendeeMuteStatus[sourceValue] === undefined) {
        extendedAttendeeMuteStatus[sourceValue] = true;
      }
    }
    return muteStatue;
  }, extendedAttendeeMuteStatus);
  return extendedAttendeeMuteStatus;
};

/**
 * This returns the media settings for media control
 *
 * @param {Array} layers program or scene layers
 * @param {Boolean} isNotMinimized defaults to true
 * @param defaultSettings
 * @returns {{videoSettings: {value: {}}, audioSettings: {value: {}}, controllerStyles: {audio: string, video: string}}}
 */
var getMediaSettings = exports.getMediaSettings = function getMediaSettings(layers) {
  var isNotMinimized = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var defaultSettings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var videoSourceLayer = layers.find(function (_ref9) {
    var source = _ref9.source;
    return isVideoSource(source);
  });
  var audioSourceLayer = layers.find(function (_ref10) {
    var source = _ref10.source;
    return isAudioSource(source);
  });
  var defaultValue = {
    value: {}
  };
  var video = (videoSourceLayer === null || videoSourceLayer === void 0 ? void 0 : videoSourceLayer.source) || defaultValue;
  var audio = (audioSourceLayer === null || audioSourceLayer === void 0 ? void 0 : audioSourceLayer.source) || defaultValue;
  var videoSettings = _objectSpread(_objectSpread({}, video), {}, {
    value: _objectSpread(_objectSpread({}, defaultSettings), video.value)
  });
  var audioSettings = _objectSpread(_objectSpread({}, audio), {}, {
    value: _objectSpread(_objectSpread({}, defaultSettings), audio.value)
  });
  var controllerStyles = {
    audio: '',
    video: ''
  };
  var noTopBorderRadiusStyle = "border-top-left-radius: unset; border-top-right-radius: unset;";
  var videoSolo = videoSettings._id && !audioSettings._id;
  var audioSolo = !videoSettings._id && audioSettings._id;
  var audioVideo = !!videoSettings._id && !!audioSettings._id;
  if (isNotMinimized) {
    if (audioVideo || videoSolo) {
      controllerStyles.video = noTopBorderRadiusStyle;
    } else if (audioSolo) {
      controllerStyles.audio = noTopBorderRadiusStyle;
    }
  }
  return {
    audioSettings: audioSettings,
    videoSettings: videoSettings,
    controllerStyles: controllerStyles
  };
};

/**
 * This returns the firstName and lastName from source title
 *
 * @param {string} title source title
 * @returns {{firstName: string, lastName: string}}
 */
var getSourceFirstNameLastName = exports.getSourceFirstNameLastName = function getSourceFirstNameLastName(title) {
  if (!title) {
    return {
      firstName: '',
      lastName: ''
    };
  }
  var words = title.split(' ');
  var firstName = words[0];
  var lastName = words.length > 1 ? words[words.length - 1] : '';
  return {
    firstName: firstName,
    lastName: lastName
  };
};